import React from 'react'
import "./Homepage_common_heading.css"

function Homepage_common_heading({headingText, headingDescText}) {
  return (
    <section className='Homepage_common_heading'>
    <div className='section_heading_div'>
          <h1 className='heading_text'>{headingText}</h1>
          <p className='heading_desc_text'>{headingDescText}</p>
        </div>
    </section>
  )
}

export default Homepage_common_heading
